import { render, staticRenderFns } from "./SizesLegend.vue?vue&type=template&id=26e6989e&scoped=true&"
import script from "./SizesLegend.vue?vue&type=script&lang=js&"
export * from "./SizesLegend.vue?vue&type=script&lang=js&"
import style0 from "./SizesLegend.vue?vue&type=style&index=0&id=26e6989e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e6989e",
  null
  
)

export default component.exports